import {useAccessPayConfiguration, useGet, useQueryWithErrorHandling} from '@app/sdk';

export function useGetSubmissions({ accountNumber }: { accountNumber: string }) {
  const get = useGet();
  const { data: accessPayConfig } = useAccessPayConfiguration();

  async function getSubmissions() {
    return await get<any>(`${accessPayConfig?.baseUrl}/debug/submissions?accountNumber=${accountNumber}`);
  }

  return useQueryWithErrorHandling({
    queryKey: ['getSubmissions', accountNumber],
    queryFn: getSubmissions,
  });
}
